import { OepaUserAccount } from "@ohioepa/oepa-common-lib";

export const extLiveReloadAccount: OepaUserAccount = {
    loginName: 'sd',
    accountID: 'sd',
    firstName: 'Sam',
    lastName: 'Davis',
    primaryEMailAddress: 'samuel.davis@epa.ohio.gov',
    type: 'E_BUSINESS_CENTER',
    roleList: [
    ]
  }